import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {string} date - the date of the dealer response
 * @param {string} children - the text of the dealer response
 */
const DealerResponse = ({ date, children }) => {
	return (
		<div className="dealerResponse ml-5 between-dotted-line">
			<p className="mb-1">{date}</p>
			<p role="note" aria-label="Dealer response">
				{children}
			</p>
		</div>
	);
};

DealerResponse.propTypes = {
	date: PropTypes.string.isRequired,
	children: PropTypes.string.isRequired
};

export default DealerResponse;
